import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-cn-print-notes',
  templateUrl: './cn-print-notes.component.html',
  styleUrls: ['./cn-print-notes.component.scss']
})
export class CnPrintNotesComponent implements OnInit {

  env:any;
  constructor() { }

  ngOnInit(): void {
    this.env=environment;
  }

}
